import { IdCard } from "lucide-react";
import { Input } from "./ui/input";
import DocUpload from "./DocUpload";

export const DL_RE = /^[A-Z]{2}[0-9]{2}[0-9A-Z]{11,12}$/;
export const VEH_RE = /^[A-Z]{2}\d{1,2}[A-Z]{0,3}\d{4}$/;
const clean = (v) => v.toUpperCase().replace(/[^A-Z0-9]/g, "");

export function riderErrors(f) {
  const e = {};
  if (f.vehicle !== "Cycle" && !DL_RE.test(f.dl_number)) e.dl_number = "Enter a valid 16-character licence number, e.g. AP1620190012345 6";
  if (f.vehicle !== "Cycle" && !VEH_RE.test(f.vehicle_number)) e.vehicle_number = "Enter a valid vehicle number, e.g. AP16AB1234";
  if (!f.rdocs.selfie) e.selfie_doc = "Take a live selfie with your phone camera";
  if (f.vehicle !== "Cycle" && !f.rdocs.dl) e.dl_doc = "Upload a photo of your driving licence";
  if (!f.rdocs.id_proof) e.id_doc = `Upload a photo of your ${f.id_type === "pan" ? "PAN" : "Aadhaar"} card`;
  return e;
}

export default function RiderKycFields({ f, upd, errors }) {
  const doc = (k) => (d) => upd((s) => ({ rdocs: { ...s.rdocs, [k]: d } }));
  const Err = ({ k }) => (errors[k] ? <p data-testid={`rider-${k}-error`} className="text-xs text-red-400 mt-1">{errors[k]}</p> : null);
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-4 space-y-3" data-testid="rider-kyc">
      <p className="text-sm font-semibold flex items-center gap-2"><IdCard size={15} className="text-[#00f0ff]" />Licence & ID verification</p>
      <DocUpload label="Take a live selfie (front camera)" doc={f.rdocs.selfie} setDoc={doc("selfie")} testid="rider-selfie-doc" error={errors.selfie_doc} capture="user" />
      {f.vehicle !== "Cycle" ? <>
        <div><Input data-testid="rider-dl-input" placeholder="Driving licence number (16 characters)" maxLength={16} value={f.dl_number} onChange={(e) => upd({ dl_number: clean(e.target.value) })} className="h-11 font-mono" /><Err k="dl_number" /></div>
        <DocUpload label="Upload driving licence photo (front)" doc={f.rdocs.dl} setDoc={doc("dl")} testid="rider-dl-doc" error={errors.dl_doc} />
      </> : <p className="text-xs text-emerald-400" data-testid="rider-cycle-no-dl">Bicycle riders don't need a driving licence.</p>}
      {f.vehicle !== "Cycle" && <div><Input data-testid="rider-vehicle-number-input" placeholder="Vehicle number (RC), e.g. AP16AB1234" maxLength={10} value={f.vehicle_number} onChange={(e) => upd({ vehicle_number: clean(e.target.value) })} className="h-11 font-mono" /><Err k="vehicle_number" /></div>}
      <div className="flex p-1 rounded-full bg-black/40 border border-white/10">
        {[["aadhaar", "Aadhaar card"], ["pan", "PAN card"]].map(([v, n]) => (
          <button key={v} type="button" data-testid={`rider-id-type-${v}`} onClick={() => upd({ id_type: v })} className={`flex-1 py-2 rounded-full text-xs font-semibold ${f.id_type === v ? "bg-white text-black" : "text-slate-300"}`}>{n}</button>
        ))}
      </div>
      <DocUpload label={`Upload ${f.id_type === "pan" ? "PAN" : "Aadhaar"} card photo`} doc={f.rdocs.id_proof} setDoc={doc("id_proof")} testid="rider-id-doc" error={errors.id_doc} />
    </div>
  );
}
